/* country-router.js — SafeWake ONE · geo-aware market router
 * Built 2026-09-05 (Mode A). Reads window.SWMarket from snippets/country-context.liquid.
 *
 * Endpoint (verified 2026-09-05 — shopify.dev "Localization discovery" + a live GET on safewakeuae.com):
 *   GET  {root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]={current}
 *   →    { "detected_values": { "country": { "handle": "KW", "name": "Kuwait" } },
 *          "suggestions": [ { "parts": { "country": { "handle": "KW", "name": "Kuwait", "confidence": 1,
 *                             "options": { "AE": "United Arab Emirates", "BH": "Bahrain", … } } },
 *                             "confidence": 1 } ] }
 *   `source=geolocation` is NOT a documented parameter and is not sent.
 * Switch (shopify.dev minimal implementation): POST {root}localization with _method=PUT,
 *   country_code=XX, return_to=<current page>. Shopify redirects to the market's subfolder / domain
 *   itself — Liquid exposes no per-country URL, so the client never guesses one.
 *
 * Never redirects:
 *   • bots / crawlers (UA pattern or navigator.webdriver)         → reason "bot"
 *   • when ?country=XX is present (the override is applied instead) → reason "override-*"
 *   • when an explicit pill choice exists (sw-country, 30 days)   → reason "manual-choice"
 *   • more than once per session (sessionStorage flag)             → reason "session-done"
 *   • non-GCC visitors — they stay on the default market           → reason "geo-non-gcc"
 * Loader hook: window.SWCountryLoader.show({country, name, reduce}) if present, else proceed.
 */
(function () {
  'use strict';
  var M = window.SWMarket;
  if (!M || !M.country) return;

  var KEY = 'sw-country';          // explicit choice: localStorage JSON {country, ts} + cookie, 30 days
  var SESSION_KEY = 'sw-geo-done'; // one geo decision per browser session (loop guard)
  var TTL_DAYS = 30;
  var BOT_RE = /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|gtmetrix|pingdom|prerender|phantomjs|facebookexternalhit|bingpreview|whatsapp|telegram|skype|linkedin|pinterest|twitter|discord|embedly|quora|yandex|baidu|duckduck|semrush|ahrefs|mj12|screaming frog/i;

  var available = (M.availableCountries || []).map(function (c) { return String(c.code || '').toUpperCase(); });
  var current = String(M.country).toUpperCase();
  var root = String(M.rootUrl || '/');
  if (root.charAt(root.length - 1) !== '/') root += '/';

  var state = {
    version: '1.0.0', current: current, action: 'none', reason: '', detected: null, target: null,
    geoCalled: false, reducedMotion: false, loaderShown: false
  };

  function isBot() {
    try {
      if (navigator.webdriver === true) return true;
      return BOT_RE.test(navigator.userAgent || '');
    } catch (e) { return false; }
  }
  function isAvailable(code) { return !!code && available.indexOf(code) !== -1; }
  function countryName(code) {
    var hit = (M.availableCountries || []).filter(function (c) { return String(c.code).toUpperCase() === code; })[0];
    return hit ? hit.name : code;
  }
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[-.]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(name, value, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax' + secure;
  }
  function readManual() {
    var fromLS = null;
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.country && o.ts && (Date.now() - o.ts) < TTL_DAYS * 864e5) fromLS = String(o.country).toUpperCase();
        else localStorage.removeItem(KEY);
      }
    } catch (e) {}
    var fromCookie = readCookie(KEY);
    return fromLS || (fromCookie ? String(fromCookie).toUpperCase() : null);
  }
  function persistManual(code) {
    try { localStorage.setItem(KEY, JSON.stringify({ country: code, ts: Date.now() })); } catch (e) {}
    try { writeCookie(KEY, code, TTL_DAYS); } catch (e) {}
  }
  function sessionDone() { try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; } }
  function markSession() { try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {} }
  function prefersReducedMotion() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }
  function returnTo() {
    try {
      var u = new URL(location.href);
      u.searchParams.delete('country');
      return u.pathname + u.search + u.hash;
    } catch (e) { return location.pathname || '/'; }
  }

  // POST the localization form. Shopify answers with a redirect to return_to inside the new market
  // (subfolder / domain included when configured) — nothing is guessed client-side.
  function submitSwitch(code) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = root + 'localization';
    form.hidden = true;
    form.setAttribute('data-sw-router-form', '1');
    var fields = { form_type: 'localization', utf8: '✓', _method: 'put', country_code: code, return_to: returnTo() };
    Object.keys(fields).forEach(function (k) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = fields[k]; form.appendChild(i);
    });
    var mount = document.body || document.documentElement;
    mount.appendChild(form);
    form.submit();
  }

  function showLoaderThen(code, done) {
    state.reducedMotion = prefersReducedMotion();
    var L = window.SWCountryLoader;
    if (L && typeof L.show === 'function') {
      state.loaderShown = true;
      try {
        var p = L.show({ country: code, name: countryName(code), reduce: state.reducedMotion });
        if (p && typeof p.then === 'function') { p.then(done, done); return; }
      } catch (e) {}
    }
    done();
  }

  function go(code, reason) {
    state.action = 'switch'; state.target = code; state.reason = reason;
    markSession();
    var fire = function () { submitSwitch(code); };
    if (document.body) showLoaderThen(code, fire);
    else document.addEventListener('DOMContentLoaded', function () { showLoaderThen(code, fire); });
  }

  // Public API — the announcement-bar pill uses these.
  //   remember(code): persist an explicit choice (30 d) without navigating.
  //   choose(code):   persist + switch (loader hook honoured). Returns false for unknown codes.
  function remember(code) {
    code = String(code || '').toUpperCase();
    if (!isAvailable(code)) return false;
    persistManual(code);
    return true;
  }
  function choose(code) {
    code = String(code || '').toUpperCase();
    if (!remember(code)) return false;
    if (code !== current) go(code, 'manual');
    return true;
  }
  window.SWCountryRouter = { state: state, remember: remember, choose: choose };

  function decide() {
    // 1. ?country=XX override wins — applied, never geo, persisted as an explicit choice.
    var override = null;
    try { override = new URL(location.href).searchParams.get('country'); } catch (e) {}
    if (override) {
      override = String(override).toUpperCase();
      if (!isAvailable(override)) { state.reason = 'override-unavailable'; return; }
      persistManual(override);
      if (override === current) { state.reason = 'override-current'; return; }
      go(override, 'override');
      return;
    }
    // 2. Bots / crawlers never move (SEO: every market URL must be indexable as served).
    if (isBot()) { state.reason = 'bot'; return; }
    // 3. Theme setting off.
    if (M.geoRouter === false) { state.reason = 'disabled'; return; }
    // 4. Explicit choice within 30 days — respected, never fought (shopify.dev guidance).
    var manual = readManual();
    if (manual) { state.reason = 'manual-choice:' + manual; return; }
    // 5. One geo decision per session.
    if (sessionDone()) { state.reason = 'session-done'; return; }
    if (typeof window.fetch !== 'function') { state.reason = 'no-fetch'; return; }
    markSession();
    // 6. Ask Shopify where the visitor is.
    state.geoCalled = true;
    var url = root + 'browsing_context_suggestions.json?country%5Benabled%5D=true&country%5Bexclude%5D=' + encodeURIComponent(current);
    fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var d = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (!d && j && j.suggestions && j.suggestions[0] && j.suggestions[0].parts && j.suggestions[0].parts.country) {
          d = j.suggestions[0].parts.country.handle;
        }
        d = d ? String(d).toUpperCase() : null;
        state.detected = d;
        if (!d) { state.reason = 'geo-empty'; return; }
        if (d === current) { state.reason = 'geo-current'; return; }
        if (!isAvailable(d)) { state.reason = 'geo-non-gcc'; return; }
        go(d, 'geo');
      })
      .catch(function () { state.reason = 'geo-error'; });
  }

  try { decide(); } catch (e) { state.reason = 'error:' + (e && e.message); }
})();
